var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"plain-text-field",attrs:{"label":_vm.label,"hide-details":"","disabled":""},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }